import React, { Component } from "react";
import EnvConfig from '../../config/env'

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span>&copy; 2019 {EnvConfig.HTML_REF}</span>
        <span className="ml-auto">
          Cung cấp bởi: 
          <a href={EnvConfig.HTML_REF} target="_blank">LinkPhar.JSC</a>
        </span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js